/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Wednesday, October 20th 2021, 1:30:28 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { Stack, Divider, StackProps } from "@mui/material";

export interface CustomStackProps extends StackProps {
  showDivider?: boolean;
}

export const HorizontalStackWidget = (props: CustomStackProps) => {
  return (
    <Stack
      direction="row"
      spacing={props.spacing ?? 2}
      divider={props.showDivider && <Divider orientation="vertical" flexItem />}
      {...props}
    >
      {props.children}
    </Stack>
  );
};

export const VerticalStackWidget = (props: CustomStackProps) => {
  return (
    <Stack direction="column" spacing={2} divider={props.showDivider && <Divider orientation="horizontal" flexItem />}>
      {props.children}
    </Stack>
  );
};
